module.exports = __webpack_public_path__ + "img/4.6930266f.jpg";